<template>
  <div class="flex flex-row w-full justify-end gap-9">
    <div class="w-full text-right relevance">DATA RELEVANCY</div>
    <div class="w-full">
      <VaSlider v-model="value[1]" class="mb-6" track-label-visible :color="color" readonly>
        <template #trackLabel="{ value }">
          <VaChip :color="bgColor" size="large">
            <span class="num" :class="textClass">{{ value }}</span> {{ emo }}
          </VaChip>
        </template>
      </VaSlider>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { useDomainStore } from '../stores/dashBoardStore'

const domainStore = useDomainStore()
const value = ref([45, domainStore.relivancy])
const emo = ref('🤯')
const color = ref('')
const bgColor = ref('')
const textClass = ref('redText')
// const props = defineProps(['relivancy'])
// const processTrackLabel = (value, order) => {
//   return order === 0 ? `min ${value}$` : `max ${value}$`
// }
// Reactive state
// const val = ref(70)

const emojis = ['🤯', '😰', '😦', '☹️', '🙁', '😐', '🙂', '😊', '😄', '😃', '😍']

const checkEmo = () => {
  if (value.value[1] < 0 || value.value[1] > 100) {
    value.value[1] = 0
  }
  // Use switch case to determine the emoji
  if (value.value[1] > 0 && value.value[1] <= 10.9) {
    emo.value = emojis[0]
  } else if (value.value[1] >= 11 && value.value[1] <= 20.9) {
    emo.value = emojis[1]
  } else if (value.value[1] >= 21 && value.value[1] <= 30.9) {
    emo.value = emojis[2]
  } else if (value.value[1] >= 31 && value.value[1] <= 40.9) {
    emo.value = emojis[3]
  } else if (value.value[1] >= 41 && value.value[1] <= 50.9) {
    emo.value = emojis[4]
  } else if (value.value[1] >= 51 && value.value[1] <= 60.9) {
    emo.value = emojis[5]
  } else if (value.value[1] >= 61 && value.value[1] <= 70.9) {
    emo.value = emojis[6]
  } else if (value.value[1] >= 71 && value.value[1] <= 80.9) {
    emo.value = emojis[7]
  } else if (value.value[1] >= 81 && value.value[1] <= 90.9) {
    emo.value = emojis[8]
  } else if (value.value[1] >= 91) {
    emo.value = emojis[9]
  } else {
    emo.value = '😱' // Fallback, should not be reached
  }
}

const backgroundColor = () => {
  if (value.value[1] <= 40.9) {
    color.value = '#d92d20'
    bgColor.value = 'rgba(217, 45, 32, 0.2)'
    textClass.value = 'redText'
  } else if (value.value[1] >= 41 && value.value[1] <= 70.9) {
    color.value = '#dc6803'
    bgColor.value = 'rgba(220, 104, 3, 0.2)'
    textClass.value = 'yellowText'
  } else if (value.value[1] >= 71 && value.value[1] <= 90.9) {
    color.value = 'rgba(42, 110, 238, 0.8)'
    bgColor.value = 'rgba(42, 110, 238, 0.2)'
    textClass.value = 'blueText'
  } else {
    color.value = '#23c45ecc'
    bgColor.value = 'rgba(35, 196, 94, 0.2)'
    textClass.value = 'greenText'
  }
}
const changeRelivancy = () => {
  value.value[1] = domainStore.relivancy
}
watch(() => value.value[1], backgroundColor)
watch(() => domainStore.relivancy, changeRelivancy)
watch(() => value.value[1], checkEmo)
// Lifecycle hook
onMounted(() => {
  //   val.value = Math.floor(Math.random() * 101)
  checkEmo()
  backgroundColor()
})
</script>
<style scoped lang="scss">
.relevance {
  font-size: 18px;
  font-weight: 500;
}

.redText {
  color: #d92d20;
}

.yellowText {
  color: #dc6803;
}

.blueText {
  color: rgba(42, 110, 238, 0.8);
}

.greenText {
  color: #23c45ecc;
}
</style>
